import {defaults} from 'lodash'
import axios from 'axios'
import store from './mainVuex';
let minutesToWait = 10;

import i18n from './i18n';

export const createClient = (options = {}) => {

  let http = axios.create(defaults({}, options));
  http.defaults.headers.post['Content-Type'] = 'application/json';
  http.defaults.headers.put['Content-Type'] = 'application/json';
  http.defaults.timeout = ((minutesToWait * 60) * 1000);

  http.interceptors.request.use(function (config) {
    config.headers['x-user-language'] = i18n.locale;
    return config;

  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });

  http.interceptors.response.use(
    response => {

      if (response.data && response.data.meta && response.data.meta.code == 500) {

        console.error("Ocorreu um erro de comunicação com o servidor, tente novamente!\n" + response.data.error);

        //window.location.reload();
      }

      return response
    },
    error => {

      var currentUrl = window.location.href;

      if (error && error.response && error.response.status) {

        if (error.response.status == 401) {

          if (currentUrl.indexOf('/auth') < 0) {
            store.dispatch('logout')
              .then(() => {
                window.location.reload();
              });
          }

        } else if (error.response.status == 403) {

          console.log("Acesso negado!!!");
          store.dispatch('logout')
            .then(() => {
              window.location.reload();
            });

        } else {

          // alert("Erro inesperado!\n" + error.response.data.message);
          console.error("Ocorreu um erro de comunicação com o servidor, tente novamente!\n" + error.response.data.message);
        }

      } else {

        if (currentUrl.indexOf('/auth') < 0) {
          // TODO - utilizar um alert em HTML e exibir a mensagem de erro
          //alert("Ocorreu um erro inesperado!\nTente novamente.");
          console.error("Ocorreu um erro de comunicação com o servidor, tente novamente!\n");
          /*store.dispatch('logout')
            .then(() => {
              window.location.reload();
            });*/
        }
      }

      return Promise.reject(error);
    }
  );

  return http
};

export default createClient()



// WEBPACK FOOTER //
// ./src/http.js